import type { ReactNode } from 'react';
import styles from './style.module.css';

type Variant = 'error' | 'success' | 'info';

type Props = {
  variant?: Variant;
  children: ReactNode;
  className?: string;
};

export function Alert({ variant = 'error', children, className }: Props) {
  return (
    <div className={`${styles.alert} ${styles[variant]}${className ? ` ${className}` : ''}`} role="alert">
      {children}
    </div>
  );
}
